import React, { useMemo } from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
// utils
import classnames from 'classnames/bind';
import { parseReportCategories } from 'utils/SVRHelper';
// styles
import styles from './ReportCardPreview.module.scss';

const cn = classnames.bind(styles);

// Sits well above what the card area can fit (~6 rows), so the list stays cheap
// without the limit itself becoming layout-critical
const VISIBLE_ROWS_LIMIT = 8;

const getAnswerType = ({ answer, open_answer }) => {
  if (!answer?.value) return 'unanswered';
  if (open_answer) return 'fill_blank';
  return answer.value;
};

const ReportCardPreview = ({ svrCategories }) => {
  // Same questions, order and labels the review page renders
  const questions = useMemo(() => parseReportCategories(svrCategories)
    .map(({ svr_questions }) => svr_questions)
    .flat(1)
    .slice(0, VISIBLE_ROWS_LIMIT), [svrCategories]);

  if (!questions.length) {
    return (
      <div className={cn('report-card-preview', 'empty')}>
        <i className={cn('fa fa-text-document', 'empty-icon')} />
        <span className={cn('empty-text')}>
          <FormattedMessage id="general.reportDoesntHaveQuestions" />
        </span>
      </div>
    );
  }

  return (
    <div className={cn('report-card-preview')}>
      {questions.map((question) => {
        const answerType = getAnswerType(question);
        return (
          <div key={question.id} className={cn('question-row')}>
            <div className={cn('icon', answerType)}>
              {answerType !== 'unanswered' && (
                answerType === 'fail' ? <i className="fa fa-times" /> : <i className="fa fa-check" />
              )}
            </div>
            <span className={cn('label')}>{question.label}</span>
          </div>
        );
      })}
    </div>
  );
};

ReportCardPreview.propTypes = {
  svrCategories: T.array,
};

ReportCardPreview.defaultProps = {
  svrCategories: [],
};

export default ReportCardPreview;
